"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartsOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const desktop_1 = require("./desktop");
const mobile_1 = require("./mobile");
const deviceBreakpointSize = 899;
function PartsOverlay(props) {
    const isLower = (0, ui_1.useScreenBreakpoint)(deviceBreakpointSize);
    const [isFullScreen, setIsFullScreen] = (0, react_1.useState)(false);
    const { isOpen, onClose } = props;
    const onCloseFullScreen = () => {
        onClose();
        setIsFullScreen(false);
    };
    const onToggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
        window.dispatchEvent(new Event('resize'));
    };
    return ((0, jsx_runtime_1.jsx)(ui_1.ModalOverlay, { isOpen: isOpen, onClose: onClose, "data-e2e": 'PartsOverlay_ModalOverlay', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: 800, unmountOnExit: true, appear: true, "data-e2e": 'PartsOverlay_CSSTransition', children: isLower ? ((0, jsx_runtime_1.jsx)(mobile_1.MobilePartsOverlay, Object.assign({}, props, { isFullScreen: isFullScreen, onCloseFullScreen: onCloseFullScreen, onToggleFullScreen: onToggleFullScreen, "data-e2e": 'PartsOverlay_MobilePartsOverlay' }))) : ((0, jsx_runtime_1.jsx)(desktop_1.DesktopPartsOverlay, Object.assign({}, props, { isFullScreen: isFullScreen, onCloseFullScreen: onCloseFullScreen, onToggleFullScreen: onToggleFullScreen, "data-e2e": 'PartsOverlay_DesktopPartsOverlay' }))) }) }));
}
exports.PartsOverlay = PartsOverlay;
